// Deal stages on watched properties (#3075, migration 249). The order is the
// pipeline order; the backend accepts exactly these values (dealStages in
// watchlist_handler.go).

export type DealStage = "researching" | "contacted" | "offer" | "bid" | "won" | "lost";

export const DEAL_STAGES: { value: DealStage; label: string }[] = [
  { value: "researching", label: "Researching" },
  { value: "contacted", label: "Contacted owner" },
  { value: "offer", label: "Offer made" },
  { value: "bid", label: "Bid placed" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
];

export function dealStageLabel(stage: string | null | undefined): string {
  return DEAL_STAGES.find((s) => s.value === stage)?.label ?? "";
}

export function isDealStage(v: unknown): v is DealStage {
  return DEAL_STAGES.some((s) => s.value === v);
}
